import { computed } from 'vue';
const __default__ = {
  name: "DailySummaryTable"
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    monthData: {
      /** @type {PropType<MonthData[]>} */
      type: Array,
      required: true
    },
    summaryKey: {
      type: String,
      required: true
    },
    summaryValue: {
      type: Array,
      required: true
    }
  },

  setup(__props) {
    const props = __props; // @ts-check

    const days = computed(() => props.monthData.length);
    return {
      __sfc: true,
      props,
      days
    };
  }

});